import { Button, makeStyles } from '@fluentui/react-components';
import { ArrowDown16Filled, ArrowUp16Filled } from '@fluentui/react-icons';
import { devComponentName } from '@morning-dashboard/helpers/isDevEnv';
import { useRefreshCounter } from '@morning-dashboard/hooks/useRefreshCounter';
import { BoxKey } from '@morning-dashboard/MorningDashboard.types';
import { Box, useFluentTokens } from '../../../../../theme/fluent';

export const useSortingButtonsStyles = makeStyles({
  controls: {
    marginLeft: 'auto',
    display: 'flex',
    flexWrap: 'wrap',
  },
});

export type SortingButtonsProps = {
  move: (index: number, direction: -1 | 1) => void;
  index: number;
  order: { key: BoxKey; order: number }[];
};

const SortingButtons: React.FC<SortingButtonsProps> = ({ move, index, order }) => {
  const classes = useSortingButtonsStyles();
  const { modeTokens } = useFluentTokens();
  const { isCustomizeOpened } = useRefreshCounter();

  return (
    isCustomizeOpened && (
      <Box {...devComponentName('SortingButtons')} className={classes.controls}>
        <Button
          icon={<ArrowUp16Filled />}
          onClick={() => move(index, -1)}
          appearance="subtle"
          disabled={index === 0}
          style={{ color: index === 0 ? 'inherit' : modeTokens.colorBrand80 }}
        />
        <Button
          icon={<ArrowDown16Filled />}
          onClick={() => move(index, 1)}
          appearance="subtle"
          disabled={index === order.length - 1}
          style={{ color: index === order.length - 1 ? 'inherit' : modeTokens.colorBrand80 }}
        />
      </Box>
    )
  );
};

export default SortingButtons;
